module.exports = __webpack_public_path__ + "img/sousuok.192722ef.png";